<template>
  <div class="SynastryInterpretCard" @click="openContent = !openContent">
    <div class="SynastryInterpretCard__main">
      <div class="SynastryInterpretCard__main__info">
        <!-- <img
          :src="findImg(interpretData.Astral1)"
          class="SynastryInterpretCard__main__info__astralName left"
        /> -->
        <div
          :style="`width: 20px; height: 20px; background-color: #d7815e; -webkit-mask: url(${findImg(interpretData.Astral1)}) no-repeat center / contain; mask: url(${findImg(interpretData.Astral1)}) no-repeat center / contain;`"
        ></div>
        <div class="SynastryInterpretCard__main__info__astralName left">
          {{ interpretData.AstralName1 }}
        </div>

        <div class="SynastryInterpretCard__main__info__AspectName">
          {{ interpretData.AspectName }}
        </div>
        <!-- <img
          :src="findImg(interpretData.Astral2)"
          class="SynastryInterpretCard__main__info__astralName left"
        /> -->
        <div
          :style="`width: 20px; height: 20px; background-color: #579ac3; -webkit-mask: url(${findImg(interpretData.Astral2)}) no-repeat center / contain; mask: url(${findImg(interpretData.Astral2)}) no-repeat center / contain;`"
        ></div>
        <div class="SynastryInterpretCard__main__info__astralName right">
          {{ interpretData.AstralName2 }}
        </div>
        <div class="SynastryInterpretCard__main__info__angle">
          {{ interpretData.DiffAngle }}
        </div>
      </div>
      <div class="SynastryInterpretCard__main__line"></div>
      <div class="SynastryInterpretCard__main__title">
        {{ interpretData.Title }}
      </div>
    </div>
    <div class="SynastryInterpretCard__content mt_6" v-show="openContent">
      <!-- <div class="SynastryInterpretCard__content__tab">
        <div
          class="SynastryInterpretCard__content__tab__item"
          :class="{ active: tabActive === 0 }"
          @click="tabActive = 0"
        >
          感情
        </div>
        <div
          class="SynastryInterpretCard__content__tab__item"
          :class="{ active: tabActive === 1 }"
          @click="tabActive = 1"
        >
          朋友
        </div>
        <div
          class="SynastryInterpretCard__content__tab__item"
          :class="{ active: tabActive === 2 }"
          @click="tabActive = 2"
        >
          職場
        </div>
        <div
          class="SynastryInterpretCard__content__tab__item"
          :class="{ active: tabActive === 3 }"
          @click="tabActive = 3"
        >
          親子
        </div>
      </div> -->
      <div class="SynastryInterpretCard__content__article">
        <div v-html="interpretData.Content"></div>
        <!-- <div
          v-show="tabActive === 0"
          v-html="interpretData.ContentOfEmotion"
        ></div>
        <div
          v-show="tabActive === 1"
          v-html="interpretData.ContentOfFriend"
        ></div>
        <div
          v-show="tabActive === 2"
          v-html="interpretData.ContentOfParentAndChild"
        ></div>
        <div
          v-show="tabActive === 3"
          v-html="interpretData.ContentOfWorkplace"
        ></div> -->
      </div>
    </div>
    <div class="SynastryInterpretCard__openBtn">
      <span class="SynastryInterpretCard__openBtn__notice" v-show="!openContent"
        >点击展开</span
      >
      <img
        src="@/assets/icon_downward.svg"
        :style="openContent ? 'transform:rotate(180deg)' : ''"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ["interpretData"],
  data() {
    return {
      planets: require("@/js/planets"),
      openContent: false,
      tabActive: 0,
    };
  },
  methods: {
    findImg(Name) {
      let planet = this.planets.find((planet) => planet.eName == Name);
      if (!planet) console.log(Name);
      return planet.imageUrlNoColor;
    },
  },
};
</script>
<style lang="scss">
@import "@/scss/_mixin.scss";

.SynastryInterpretCard {
  width: 100%;
  background: linear-gradient(180deg, rgba(26, 23, 48, 0.94) 0%, rgba(9, 12, 30, 0.94) 100%);
  border: 1px solid rgba(102, 224, 244, 0.2);
  box-shadow: 0 12px 28px rgba(3, 4, 32, 0.5);
  border-radius: 10px;
  padding: 20px 16px 12px;
  @include mobile {
    padding: 16px;
  }
  &__main {
    width: 100%;
    &__info {
      display: flex;
      align-items: center;
      font-size: 18px;
      line-height: 26px;
      color: #cfdbff;
      @include mobile {
        font-size: 16px;
      }
      img {
        width: 30px;
        height: 30px;
        margin-top: 2px;
        width: 20px;
      }
      &__astralName {
        display: inline-block;
        &.left {
          color: #d7815e;
        }
        &.right {
          color: #579ac3;
        }
      }
      &__AspectName {
        // min-width: 66px;
        text-align: center;
        margin: 0 16px;
        color: #cfdbff;
        @include mobile {
          min-width: 50px;
          margin: 0 12px;
        }
      }

      &__angle {
        text-align: center;
        min-width: 28px;
        margin-left: 4px;
        border: 1px solid rgba(102, 224, 244, 0.22);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08), 0 6px 12px rgba(3, 4, 32, 0.45);
        color: #f4f7ff;
        font-size: 14px;
        line-height: 1.5;
        padding: 2px 2px 2px 4px;
        border-radius: 6px;
        margin-left: 12px;
        @include mobile {
          min-width: 25px;
          font-size: 12px;
          padding: 2px 2px 2px 4px;
        }
      }
    }
    &__title {
      font-size: 14px;
      line-height: 18px;
      color: #66e0f4;
      margin-top: 12px;
      text-align: center;
      @include mobile {
        font-size: 14px;
        line-height: 18px;
      }
    }
  }
  &__content {
    &__tab {
      display: flex;
      justify-content: space-around;
      position: relative;
      &__item {
        flex-grow: 1;
        font-size: 14px;
        line-height: 18px;
        color: #868686;
        text-align: center;
        cursor: pointer;
        position: relative;
        &:hover {
          color: #798da5;
        }
        &.active {
          color: #798da5;
          &:after {
            content: "";
            position: absolute;
            height: 4px;
            width: 100%;
            border-radius: 2px;
            left: 0;
            bottom: -8px;
            background-color: #798da5;
          }
        }
      }
      &:after {
        content: "";
        position: absolute;
        height: 4px;
        width: 100%;
        box-shadow: 2px 2px 4px 0 rgba(238, 109, 175, 0.22),
          inset 2px 2px 4px 0 rgba(0, 0, 0, 0.15);
        border-radius: 2px;
        left: 0;
        bottom: -8px;
      }
    }
    &__article {
      font-size: 14px;
      line-height: 18px;
      color: #cfdbff;
      margin-top: 20px;
      @include mobile {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
  &__openBtn {
    margin-left: auto;
    width: 100%;
    height: 20px;
    margin-top: 4px;
    position: relative;
    top: 8px;
    cursor: pointer;
    img {
      position: absolute;
      top: 0%;
      right: 0;
      width: 20px;
      height: 20px;
    }
    &__notice {
      position: absolute;
      top: 0%;
      left: 50%;
      transform: translateX(-50%);
      font-size: 12px;
      line-height: 16px;
      color: #b7c8f3;
      @include mobile {
        font-size: 10px;
        line-height: 14px;
      }
    }
  }
}
</style>